import { firebaseAuth, firebaseDb } from "@/infrastructure/firebase";
import { AppAction } from "@/features/applications";
import Loader from "@/components/Loader";
import { oc } from "ts-optchain";

import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
interface IProps {
  Component: ModuleRoute["component"];
  path: string;
  exact: boolean;
  admin?: boolean;
}

export default ({ Component, path, exact, admin }: IProps) => {
  const dispatch = useDispatch();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    !initialized && dispatch(AppAction.updateUserInfoLoading("REQUEST"));
  }, [initialized]);

  // wait for firebase auth to init before creating the app
  firebaseAuth.onAuthStateChanged(cred => {
    dispatch(AppAction.updateUserInfo({ isSuperuser: !!cred }));
    dispatch(AppAction.updateUserInfoLoading("SUCCESS"));

    if (cred) {
      // if user login:
      firebaseDb
        .collection("users")
        .where("userId", "==", cred.uid)
        .get()
        .then(snapshot => {
          if (snapshot.empty) {
            console.log("No matching user Info found...");
            return;
          }

          snapshot.forEach(doc => {
            const userInfo = doc.data();
            dispatch(
              AppAction.updateUserInfo({
                username: userInfo.username,
                userId: userInfo.userId,
                email: userInfo.email,
                watchlist: oc(userInfo).watchlist({}),
                priceAlert: oc(userInfo).priceAlert([]),
                userPreference: userInfo.userPreference
              })
            );
          });
        })
        .catch(err => {
          console.log("Unable to get userInfo", err);
        });
    }
    setInitialized(true);
  });

  return initialized ? (
    <Route
      path={path}
      exact={exact}
      render={props => (admin && !firebaseAuth.currentUser ? <Redirect to="/login" /> : <Component {...props} />)}
    />
  ) : (
    <Loader />
  );
};
